import { render, staticRenderFns } from "./CareTeamComponent.vue?vue&type=template&id=e63ed130&scoped=true"
import script from "./CareTeamComponent.vue?vue&type=script&lang=js"
export * from "./CareTeamComponent.vue?vue&type=script&lang=js"
import style0 from "./CareTeamComponent.vue?vue&type=style&index=0&id=e63ed130&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e63ed130",
  null
  
)

export default component.exports